import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import Breadcrumb from '../../common/breadcrumb';
import WaitForValidation from 'components/auth/waitForValidation';
import LeadersDashboard from '../leaders';

const Default = () => {
  const userValidated = useSelector(({ Auth }) => Auth.user.validated);
  const userRole = useSelector(({ Auth }) => Auth.user.role);

  if (!userValidated) {
    return <WaitForValidation />
  }

  if (userRole === 'leader') {
    return <LeadersDashboard />
  }

  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Default" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>Sample Card</h5><span>lorem ipsum dolor sit amet, consectetur adipisicing elit</span>
              </div>
              <div className="card-body">
                <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Default;